/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import address from 'forms/shared/validators/models/location/models/address';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { isPVQForm } from 'helpers/form';
import { hasYesOrNo } from 'models/validate';
import { REQUIRED } from 'constants/errors';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { handingProtectedInformationFrequencyOptions, handlingProtectedInformationDisciplinaryOptions, systemITLocationOptions } from 'constants/enums/informationTechnologyOptions';
import { isSafeUnitedStates } from 'helpers/locations';
import { LegalTechnologyUnlawfulUseItemModel } from '../types';

export const legalTechnologyUnlawfulUseItemValidator: ValidateJSModel<LegalTechnologyUnlawfulUseItemModel> = {
  Date: (value, attributes, attributeName, options = {}) => {
    const { applicantBirthdate } = options;
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        date: {
          requireDay: false, earliest: applicantBirthdate, latest: DEFAULT_LATEST
        },
      };
    }
    return {
      presence: true,
      date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
    };
  },
  Incident: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes?.UnlawfulAccessLocations?.values?.includes('Other')) {
        return { presence: true, hasValue: true };
      }
      return {};
    }
    return { presence: true, hasValue: true };
  },

  Location: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        location: {
          validator: pvqLocationModelValidator,
          requireStreet: isSafeUnitedStates(value),
          requireIsMilitaryDiplomaticAddress: true,
          requireMilitaryDiplomaticInstallationName: true,
          requireApoFpoDpoPostcode: !isSafeUnitedStates(value),
        }
      };
    }

    return { presence: true, location: { validator: address } };
  },
  Action: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return { presence: true, hasValue: true };
  },
  UnlawfulAccessLocations: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        array: {
          length: { minimum: 1, message: REQUIRED },
          validator: { inclusion: systemITLocationOptions },
        }
      };
    }

    return {};
  },

  SystemName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  SystemOwner: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.SystemOwnerNotApplicable?.applicable === true) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  SystemOwnerNotApplicable: {},
  HadSuccess: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },

  Frequency: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)
    && attributes?.HadSuccess?.value === 'Yes') {
      return {
        hasValue: {
          validator: {
            inclusion: {
              within: handingProtectedInformationFrequencyOptions,
            },
          },
        },
      };
    }
    return {};
  },
  FrequencyOtherExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)
      && attributes?.HadSuccess?.value === 'Yes'
      && attributes?.Frequency?.value === 'Other'
    ) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  IsShared: {}, // Not used
  SharedName: {}, // not used

  Reason: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.HadSuccess?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  UnauthorizedActions: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.HadSuccess?.value === 'Yes') {
      return {
        array: {
          length: {
            message: REQUIRED,
            minimum: 1,
          },
          validator: {
            inclusion: handlingProtectedInformationDisciplinaryOptions,
            presence: true,
          }
        },
        presence: true,
      };
    }
    return {};
  },
  ActionDetails: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.HadSuccess?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  ActionOtherDetails: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.HadSuccess?.value === 'Yes'
     && attributes?.UnauthorizedActions?.values?.includes('Other')) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

};
